// extracted by mini-css-extract-plugin
export default {"wrapper":"PYePt78ymR9Q_6sd2zcX","textarea":"Z3dr_wSTIY7GyZ203cQa"};